import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartBar,
  faUser,
  faCog,
  faSignOutAlt,
  faFileAlt,
  faBars,
  faTimes,
  faHome,
  faList,
  faUsers,
  faPlusSquare,
} from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import logoFull from "../../src/assets/images/logo_white.png";
import logoCollapsed from "../../src/assets/images/logo_m_white.png";
import { useNavigate } from "react-router-dom";
const Sidebar = ({ onCollapseChange }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const [activeRoute, setActiveRoute] = useState(location.pathname);
  useEffect(() => {
    setActiveRoute(location.pathname);
  }, [location.pathname]);

  const activeLinkStyles = {
    backgroundColor: "#cfc9ff",
  };

  const activeIconAndTextStyles = {
    color: "black",
  };
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
    onCollapseChange(!isCollapsed);
  };

  const handleLogout = () => {
    console.log("Logout clicked");
    Cookies.remove("token");
    Cookies.remove("user");

    navigate("/login", { replace: true });
    window.location.reload();
  };

  const menuItems = [
    { name: "Dashboard", to: "/", icon: faHome },
    // { name: "Template", to: "/templates", icon: faList },
    // { name: "Send", to: "/", icon: faUser },
    // { name: "Create", to: "/", icon: faUsers },
    { name: "Documents", to: "/signed-documents", icon: faFileAlt },
  ];

  return (
    <div
      style={{ height: "-webkit-fill-available " }}
      className={`fixed top-0 left-0 z-50 bg-gray-800 text-white transition-all duration-300 ease-in-out ${
        isCollapsed ? "w-16" : "w-56"
      }`}
    >
      <div className=" hidden sm:flex flex-col items-center p-4">
        {" "}
        {isCollapsed ? (
          <img src={logoCollapsed} alt="Logo" className="w-8 h-8 mb-4" />
        ) : (
          <div className="flex items-center justify-between w-full">
            <img src={logoFull} alt="Logo" className="w-40" />
            <button onClick={toggleCollapse} className="focus:outline-none">
              <FontAwesomeIcon icon={faTimes} size="lg" />
            </button>
          </div>
        )}
        {isCollapsed && (
          <button onClick={toggleCollapse} className="focus:outline-none">
            <FontAwesomeIcon icon={faBars} size="lg" />
          </button>
        )}
      </div>

      <nav className="mt-4">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.name} className="relative">
              <Link
                to={item.to}
                className={`flex items-center space-x-3 py-2 px-4 hover:bg-gray-700 rounded-md transition-colors duration-200 ${
                  isCollapsed ? "justify-center" : ""
                }`}
                style={activeRoute === item.to ? activeLinkStyles : {}}
                onClick={() => setActiveRoute(item.to)}
              >
                <FontAwesomeIcon
                  icon={item.icon}
                  size="lg"
                  className={
                    activeRoute === item.to ? "text-black" : "text-gray-400"
                  }
                />
                {!isCollapsed && (
                  <span
                    style={
                      activeRoute === item.to ? activeIconAndTextStyles : {}
                    }
                  >
                    {item.name}
                  </span>
                )}
              </Link>
            </li>
          ))}

          <li className="absolute bottom-4 w-full">
            <button
              onClick={handleLogout}
              className={`flex items-center space-x-3 py-2 px-4 hover:bg-gray-700 rounded-md transition-colors duration-200 w-full ${
                isCollapsed ? "justify-center" : ""
              }`}
            >
              <FontAwesomeIcon
                icon={faSignOutAlt}
                size="lg"
                className="text-gray-400"
              />
              {!isCollapsed && <span>Logout</span>}
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
